module.exports = "/_next/static/images/about-feature02-a4c439dc505d3c36eff4ba3a2aa855ce.jpg";